import { useEffect } from 'react';
import { Heading, Paragraph, Table } from '@zillow/constellation-10';
import type { CreditReportType } from '@zg-rentals/ts-capps-client';
import { formatDate } from '@zg-rentals/formatters';
import { getCreditInquiries } from '@zg-rentals/applications-utils';
import type { EmitMetric } from '../../models/report-models';
import { ReportType } from '../../models/report-models';
import { countReportData } from '../../utils/report-utils';

export function CreditReportInquiries({
  creditReport,
  emitMetric,
}: {
  creditReport: CreditReportType;
  emitMetric: EmitMetric;
}) {
  const inquires = getCreditInquiries(creditReport);

  useEffect(() => {
    countReportData(ReportType.CreditReport, 'inquires', inquires?.length, emitMetric);
  }, []);

  return (
    <>
      <Heading level={3} textStyle="heading-xs" css={{ marginTop: 'md', marginBottom: 'xs' }}>
        Credit inquiries
      </Heading>
      {inquires.length > 0 && (
        <Table.Responsive>
          <Table.Root aria-label="Inquiries table" appearance="horizontal" alignments={['left', 'right']} size="sm">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Inquirer</Table.HeaderCell>
                <Table.HeaderCell>Date</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {inquires.map((inquiry) => (
                <Table.Row key={`${inquiry.date}-${inquiry.name}`}>
                  <Table.HeaderCell>{inquiry.name}</Table.HeaderCell>
                  <Table.Cell>{formatDate(inquiry.date, 'numbers')}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table.Root>
        </Table.Responsive>
      )}
      {!inquires.length && <Paragraph textStyle="body-sm">None found</Paragraph>}
    </>
  );
}
